/* Pattern for ad hoc query against relay store */
import { fetchQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
      
const query = graphql`
query AccountFetchQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    parentId
    accountId
    accountStatus
    accountType
    accountNum
    accountName
    description
    contactLastName
    contactFirstName
    contactEmail
    contactPhone
    address1
    address2
    city
    state
    country
    postalCode
    accountConfirmDate
    achConfirmDate
    dwollaCid
    stripeCid
    hubspotId
    achActive
    leaddynoId
    leaddynoEmail
    logo
    accountFeatureTsByAccountId {
      totalCount
      nodes {
        flagName
        flagValue
        flagValueTxt
      }
    }
    paymentSourceTsByAccountId {
      totalCount
      nodes {
        psType
      }
    }
    accountTByParentId {
      accountId
      accountName
      accountFeatureTsByAccountId {
        totalCount
        nodes {
          flagName
          flagValue
          flagValueTxt
        }
      }
    }
  }
}
`;

function fetch(acctId) {
  const variables = {
    accountId: acctId
  }
  
  return fetchQuery(
    abEnvironment.getEnvironment(),
    query,
    variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };

